import React from 'react';
import { Link } from "react-router-dom";
export const Logo = Props => {
    return(
        <Link className ="logo"  to ={Props.url}>
        <h1> Bob Nurse Motors</h1>
        <small>repair&nbsp;used cars</small>
        </Link>
    )
}